import { DETAIL_PAGE_ACTIONS } from "./actionTypes";
import { axiosCmsAPI, axiosContentDetail, axiosHomeScreen } from "../axios";
import { getPlayingVideo } from "../util/commonFunctions";
import { getContentWithLanguage } from "../util/language";
import { handleActionError } from "../util/error";

const homeSectionUrl = "/section/";
const latestRailUrl = "/pub/api/v1/vod/latest";
const topicRailUrl = "/pub/api/vod/topic/";
const seriesRailUrl = "/pub/api/vod/event/series/";
const relatedRailUrl = "/pub/api/related/vod/";
const storefrontMedia = "/media/";
const vodUrl = "/pub/api/v1/vod";

const getRailUrl = (railType, id = null ) => {
  let railUrl;
  switch (railType) {
    case 'latest':
      railUrl = latestRailUrl
      break;
    case 'topic_driven':
      railUrl = topicRailUrl + id;
      break;
    case 'series_driven':
      railUrl = seriesRailUrl + id;
      break;
    default:
      railUrl = topicRailUrl + id;
      break;
  }
  return railUrl;
}

export const getDetailDataInitialLoad = (videoId, sectionId, language) => async (
  dispatch,
  getState,
  api
) => {
  try {
    let railData;
  
    let homeSectionDetailData = await axiosHomeScreen.get(
      homeSectionUrl + sectionId
    );

    homeSectionDetailData = getContentWithLanguage(homeSectionDetailData.data, language);

    if (
      homeSectionDetailData.railType &&
      homeSectionDetailData.railType.toLowerCase() == "custom"
    ) {
      railData = homeSectionDetailData.contentList;
    } else if (
      homeSectionDetailData.railType &&
      homeSectionDetailData.railType.toLowerCase() == "auto"
    ) {
      const railUrl = getRailUrl(homeSectionDetailData.subType.toLowerCase(), homeSectionDetailData?.topic?.id);
      
      railData = await axiosContentDetail.get(
        `${railUrl}?offset=0&max=${homeSectionDetailData.numberOfVODs}`
      );

      railData =
        homeSectionDetailData.subType.toLowerCase() == "latest"
          ? railData.data.data
          : railData.data.data.contentResults;
      
    }
  
      railData = getContentWithLanguage(railData, language);
  
    const getVideo = getPlayingVideo(railData, videoId);
  
    if (getVideo) {
      dispatch({
        type: DETAIL_PAGE_ACTIONS.SET_PLAYING_VIDEO,
        payload: { data: getVideo }
      });
      dispatch({
        type: DETAIL_PAGE_ACTIONS.HOME_PAGE_SECTION._SUCCESS,
        payload: { data: homeSectionDetailData }
      });
      dispatch({
        type: DETAIL_PAGE_ACTIONS.RAIL._SUCCESS,
        payload: { data: railData, videoId: videoId }
      });
    } else {
      return dispatch(getRelatedDetailDataInitialLoad(videoId, language));
    }
  } catch (e){
     handleActionError("An error occurred with fetching and loading home section data", e);
  }
};

export const getRelatedDetailDataInitialLoad = (videoId, language) => async (
  dispatch,
  getState,
  api
) => {

  try {
    const relatedVodData = await axiosContentDetail.get(
      `${vodUrl}?id=${videoId}`
    );
    const relatedSectionData = await axiosContentDetail.get(
      `${relatedRailUrl}${videoId}?offset=0&max=9`
    );
    const updated = Promise.all(relatedSectionData.data.data.contentResults.map(async(item) => {
      try {
        const response = await axiosCmsAPI.get(
          `${storefrontMedia}${item.id}`
        );
        if(await response.data.hasOwnProperty('transcript')) {
          return {...item, transcript: await response.data.transcript}
        }else {
          return item
        }
      }catch(error) {
        console.log('Error getting rail transcript:', error)
        handleActionError('Error getting rail transcript:', error)
      }
    }))

    const transcript = await axiosCmsAPI.get(
      `${storefrontMedia}${videoId}`
    );

    const parsedVodData = getContentWithLanguage({...relatedVodData.data.data, transcript: transcript.data.transcript}, language);
  
    let relatedRail = getContentWithLanguage(await updated, language);
  
    relatedRail.unshift(parsedVodData);
    dispatch({
      type: DETAIL_PAGE_ACTIONS.SET_PLAYING_VIDEO,
      payload: { data: parsedVodData }
    });
    dispatch({
      type: DETAIL_PAGE_ACTIONS.RAIL._SUCCESS,
      payload: {
        data: relatedRail,
        videoId: videoId
      }
    });
  } catch (e){
    handleActionError("An error occurred while fetching related VOD data:", e);
  }
  
};

export const setRailData = (railData, videoId) => {
  return dispatch => {
    dispatch({
      type: DETAIL_PAGE_ACTIONS.RAIL._SUCCESS,
      payload: { data: railData, videoId: videoId }
    });
  };
};

export const removeDetailPageData = () => {
  return dispatch => {
    dispatch({
      type: DETAIL_PAGE_ACTIONS.RESET
    });
  };
};

export const getHomePageSection = ({ sectionId, language }) => {
  return dispatch => {
    dispatch({
      type: DETAIL_PAGE_ACTIONS.HOME_PAGE_SECTION._START
    });
    return axiosHomeScreen
      .get(homeSectionUrl + sectionId)
      .then(response => {
        const filteredByLanguage = getContentWithLanguage(response.data, language);
        // console.log("Home page section by language", filteredByLanguage);
        dispatch({
          type: DETAIL_PAGE_ACTIONS.HOME_PAGE_SECTION._SUCCESS,
          payload: { data: filteredByLanguage }
        });
      })
      .catch(error => {
        handleActionError("An error occurred retrieving home page section data", error);
        dispatch({
          type: DETAIL_PAGE_ACTIONS.HOME_PAGE_SECTION._FAILURE
        });
      });
  };
};

export const getAutoRail = (noVod, railType, id, videoId, language) => {
  return dispatch => {
    dispatch({
      type: DETAIL_PAGE_ACTIONS.RAIL._START
    });
    const railUrl = getRailUrl(railType, id);
    
    return axiosContentDetail
      .get(`${railUrl}?offset=0&max=${noVod}`)
      .then(response => {
        const { data = {} } = response;
        let railData =
          railType == "latest" ? data.data : data.data.contentResults;
        
        console.log("RAIL DATA", railData);
        railData = getContentWithLanguage(railData, language);
        dispatch({
          type: DETAIL_PAGE_ACTIONS.RAIL._SUCCESS,
          payload: { data: railData, videoId: videoId }
        });
      })
      .catch(error => {
        handleActionError("An error occurred while fetching rail VOD data:", error);
        dispatch({
          type: DETAIL_PAGE_ACTIONS.RAIL._FAILURE
        });
      });
  };
};

export const getRelatedRail = (videoId, language) => {
  return dispatch => {
    dispatch({
      type: DETAIL_PAGE_ACTIONS.RAIL._START
    });
    return axiosContentDetail
      .get(`${vodUrl}?id=${videoId}`)
      .then(response => {
        return axiosContentDetail
          .get(`${relatedRailUrl}${videoId}?offset=0&max=9`)
          .then(resTopicRail => {
            let relatedRail = getContentWithLanguage(resTopicRail.data.data.contentResults, language);
            // Add to beginning of list
            relatedRail.unshift(getContentWithLanguage(response.data.data, language));
            dispatch({
              type: DETAIL_PAGE_ACTIONS.RAIL._SUCCESS,
              payload: {
                data: relatedRail,
                videoId: videoId
              }
            });
          })
          .catch(err => handleActionError("An error ocurred while fetching related VODs:", err));
      })
      .catch(error => {
        handleActionError("An error occurred while fetching VOD data", error);
        dispatch({
          type: DETAIL_PAGE_ACTIONS.RAIL._FAILURE
        });
      });
  };
};
